let navigateGlobal: any;

export const setNavigate = (navigate: any) => {
  navigateGlobal = navigate;
};

export const getNavigate = () => navigateGlobal;
